import { Route, Routes, Navigate } from "react-router-dom";
import ForgetPassword from "../pages/auth/forgot password";
import ResetPassword from "../pages/auth/reset password";
import Signin from "../pages/auth/signin";

export default function AuthRoutes() {
  return (
		<Routes>
			<Route path="/sign-in" element={<Signin />} />
			<Route path="/forgot-password" element={<ForgetPassword />} />
			<Route path="/reset" element={<ResetPassword />} />
			<Route path="/*" element={<Navigate to="/sign-in" replace />} />
		</Routes>
	);
}